import { formatISO, parseISO } from 'date-fns';
import { EditMemberGroup } from '../models';
import { upsertMember } from './api';

export function saveMemberGroup(memberGroup: EditMemberGroup) {
  const primaryAddress = {
    address_line_1: memberGroup.primary.addressLine1!,
    address_line_2: memberGroup.primary.addressLine2,
    city: memberGroup.primary.city!,
    state: memberGroup.primary.state!,
    zip_code: memberGroup.primary.zipCode!,
  };

  const apiMembers = memberGroup.dependents.concat(memberGroup.primary).map(member => {
    const apiMember = {
      client_id: memberGroup.clientId,
      // If the primary has an externalEmployeeId already set, use that for all members in the group
      //  otherwise (if the primary is being saved for the first time), use the primary's ssn
      external_employee_id: memberGroup.primary.externalEmployeeId ?? memberGroup.primary.ssn,
      first_name: member.firstName,
      last_name: member.lastName,
      date_of_birth: formatISO(parseISO(member.birthDate)),
      identification_code: member.ssn,
      relationship_code: member.relationshipCode,
      organization_id: memberGroup.organizationId,
      benefit_plan_name: memberGroup.benefitPlanName,
      coverage_tier: memberGroup.coverageTier,
      benefit_start_date: member.benefitStartDate,
      benefit_end_date: member.benefitEndDate || undefined, // convert ''
      address_line_1: member.addressLine1!,
      address_line_2: member.addressLine2,
      city: member.city!,
      state: member.state!,
      zip_code: member.zipCode!,
      invoice_group: memberGroup.invoiceGroup || '', //TODO: revisit this, as it might break with the new membership service.
      email: member.email, // Known bug that email and phone cannot be deleted from the eligibility portal, due to member flattening with last defined memberReceived value.
      home_phone_number: member.phone,
      ...(member.isAddressSameAsPrimary ? primaryAddress : undefined),
    };

    return upsertMember(member.id, apiMember);
  });

  return Promise.all(apiMembers);
}
